import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class GlobalService {
    private shippingIdSubject = new BehaviorSubject<string>("");
    shippingId$ = this.shippingIdSubject.asObservable();

    private proceedToPaymentSubject = new Subject<void>();
    proceedToPayment$ = this.proceedToPaymentSubject.asObservable();

    private stripeSurchargePercentSubject = new BehaviorSubject<number>(0);
    stripeSurchargePercent$ = this.stripeSurchargePercentSubject.asObservable();

    private isStripeSelectedSubject = new BehaviorSubject<boolean>(false);
    isStripeSelected$ = this.isStripeSelectedSubject.asObservable();

    private selectedPaymentMethodSubject = new BehaviorSubject<string | null>(
        null
    );
    selectedPaymentMethod$ = this.selectedPaymentMethodSubject.asObservable();

    setShippingId(id: string) {
        this.shippingIdSubject.next(id);
    }

    setSelectedPaymentMethod(methodCode: string | null) {
        this.selectedPaymentMethodSubject.next(methodCode);
    }

    triggerProceedToPayment() {
        this.proceedToPaymentSubject.next();
    }

    setStripeSurchargePercent(percent: number) {
        this.stripeSurchargePercentSubject.next(percent);
    }

    setIsStripeSelected(isSelected: boolean) {
        this.isStripeSelectedSubject.next(isSelected);
    }
}
